import { useState, useEffect } from 'react';
import { TIMELINE_GUTTER_WIDTH, TIMELINE_START_HOUR, TIMELINE_END_HOUR } from '../../../lib/timeline';

interface TimelineNowIndicatorProps {
  startHour?: number;
  endHour?: number;
  toPixel: (minutes: number) => number;
}

export function TimelineNowIndicator({ startHour = TIMELINE_START_HOUR, endHour = TIMELINE_END_HOUR, toPixel }: TimelineNowIndicatorProps) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(interval);
  }, []);

  const minutes = now.getHours() * 60 + now.getMinutes();
  const isVisible = minutes >= startHour * 60 && minutes <= endHour * 60;
  if (!isVisible) return null;

  const top = toPixel(minutes);
  const timeStr = now.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

  return (
    <div className="absolute left-0 right-0 z-20 pointer-events-none" style={{ top }}>
      <div
        className="absolute -top-[3px] -ml-[3px] w-1.5 h-1.5 rounded-full bg-accent shadow-sm shadow-accent/40"
        style={{ left: TIMELINE_GUTTER_WIDTH }}
      />
      <div
        className="absolute right-0 border-t border-accent/50"
        style={{ left: TIMELINE_GUTTER_WIDTH, borderStyle: 'solid' }}
      />
      <span className="absolute right-1 -top-4 text-[11px] font-mono font-medium text-accent select-none leading-none whitespace-nowrap">
        {timeStr}
      </span>
    </div>
  );
}
